import { render, staticRenderFns } from "./DialogConfirmIcon.vue?vue&type=template&id=3a4044d1&scoped=true"
import script from "./DialogConfirmIcon.vue?vue&type=script&lang=ts"
export * from "./DialogConfirmIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4044d1",
  null
  
)

export default component.exports